/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    class StoreSelectorPopup extends HTMLElement {
        cookieName = 'selected_country';
        domain = 'usecadence.com';

        constructor() {
            super();
        }

        connectedCallback() {
            this.form = this.querySelector('form');
            this.form.addEventListener('submit', this.submit.bind(this));
            this.closeButton = this.querySelector('[data-close]');
            this.closeButton.addEventListener('click', this.close.bind(this));
            this.countrySelect = this.querySelector('[name="country_code"]');
            this.country = this.getCookie(this.cookieName);
            if (!this.country) {
                this.geoIP();
            } else {
                this.evaluateCountry();
            }
        }

        evaluateCountry() {
            if (this.country === 'US' && window.location.hostname.startsWith('usecadence.com')) {
                this.show()
            } else if (this.country === 'GB' && window.location.hostname.startsWith('us.usecadence')) {
                this.show();
            }
        }

        show() {
            this.setAttribute('data-open', '');
        }

        close() {
            this.removeAttribute('data-open');
        }

        submit(event) {
            event.preventDefault();
            const selected = this.countrySelect.options[this.countrySelect.selectedIndex];
            const url = selected.dataset.url;
            this.setCountry(selected.value);
            if (window.location.hostname === this.getHostnameFromUrl(url)) {
                this.close();
            } else {
                window.location.href = url;
            }
        }

        geoIP() {
            fetch('/browsing_context_suggestions.json')
                .then((res) => res.json())
                .then((res) => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const country = urlParams.get('country') || res.detected_values.country.handle;
                    this.setCountry(country);
                    this.evaluateCountry()
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        setCountry(country) {
            this.country = country;
            this.setCookie(this.cookieName, this.country);
        }

        setCookie(name, value, options = {}) {
            options = {
                domain: this.domain,
                path: '/',
                value: '1',
            };

            if (options.expires instanceof Date) {
                options.expires = options.expires.toUTCString();
            }

            let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

            for (let optionKey in options) {
                updatedCookie += '; ' + optionKey;
                let optionValue = options[optionKey];
                if (optionValue !== true) {
                    updatedCookie += '=' + optionValue;
                }
            }

            document.cookie = updatedCookie;
        }

        getCookie(name) {
            let matches = document.cookie.match(
                new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
            );
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }

        getHostnameFromUrl(url) {
            try {
                const parsedUrl = new URL(url);
                return parsedUrl.hostname; // Returns the domain (e.g., "example.com")
            } catch (error) {
                console.error("Invalid URL:", error);
                return null;
            }
        }
    }

    if (!customElements.get('store-selector-popup')) {
        customElements.define('store-selector-popup', StoreSelectorPopup);
    }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
